module.exports = __webpack_public_path__ + "static/media/More.456893fa.svg";